<template>
  <div
    class="item mb-0 shadow-sm pl-1 pr-1 justify-content-center"
    :class="{
      'bg-dark text-white': item.id === value
    }"
    :title="name"
    @click="updateActive(item.id)"
    v-if="name !== 'warehouse'"
    style="display: flex;"
  >
    <div
      style="
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        direction: rtl;
      "
    >
      {{ name }}
    </div>
    <div class="pl-3">
      <b-button
        class="mx-3 my-0 p-0"
        :class="{
          'text-dark': removeConfirm === 0 && item.id != value,
          'text-white': item.id === value,
          'text-danger': removeConfirm === 1
        }"
        @click="removeContainer(item)"
        @blur="resetRemoveConfirmation()"
        style="outline: none; background: transparent; border: none; box-shadow: none;"
      >
        <b-icon-trash-fill></b-icon-trash-fill>
      </b-button>
      <b-button
        class="mx-3 my-0 p-0"
        :class="{
          'text-dark': editConfirm === 0 && item.id != value,
          'text-white': item.id === value,
          'text-danger': editConfirm === 1
        }"
        @click="editContainer(item)"
        @blur="resetEditConfirmation()"
        style="outline: none; background: transparent; border: none; box-shadow: none;"
      >
        <b-icon-gear-fill></b-icon-gear-fill>
      </b-button>
      <b-button
        class="mx-1 my-0 p-0"
        :class="{
          'text-dark': lockConfirm === 0 && item.id != value,
          'text-white': item.id === value,
          'text-danger': lockConfirm === 1
        }"
        @click="lockContainer(item)"
        @blur="resetLockConfirmation()"
        style="outline: none; background: transparent; border: none; box-shadow: none;"
      >
      <span v-if="item.lock"><b-icon-lock-fill></b-icon-lock-fill></span>
      <span v-else><b-icon-unlock-fill></b-icon-unlock-fill></span>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContainerWidgetSummary',
  props: ['item', 'name', 'value'],
  data() {
    return {
      removeConfirm: 0,
      editConfirm: 0,
      lockConfirm: 0,
    };
  },
  methods: {
    updateActive(value) {
      if (!this.item.lock) {
        this.$emit('input', value);
      }
    },
    resetRemoveConfirmation() {
      this.removeConfirm = 0;
    },
    resetEditConfirmation() {
      this.editConfirm = 0;
    },
    resetLockConfirmation() {
      this.lockConfirm = 0;
    },
    removeContainer(value) {
      this.removeConfirm += 1;
      if (this.removeConfirm === 2) {
        this.$emit('remove_container', value);
      }
    },
    editContainer(value) {
      this.editConfirm += 1;
      if (this.editConfirm === 2) {
        this.$emit('edit_container', value);
      }
    },
    lockContainer(value) {
      this.lockConfirm += 1;
      if (this.lockConfirm === 2) {
        this.$emit('lock_container', value);
        this.resetLockConfirmation();
        if (this.item.lock) {
          this.$emit('input', '');
        }
      }
    },
  },
};
</script>

<style scoped>

</style>
